import { HighlightedMappingMapType, MasterDescriptorWithHorizontalLevelType } from '../../../../../../types';
import createColorGradient from '../../../../../../utils/colorGradients';

const getColorFromConfidence = createColorGradient();

type GetMasterDescriptorStylingReturnType = {
    styles: Record<string, any>;
    classes: string;
};

export function getMasterDescriptorStyling(
    masterDescriptor: MasterDescriptorWithHorizontalLevelType,
    highlightedMappingsMap: HighlightedMappingMapType
): GetMasterDescriptorStylingReturnType {
    const styles: Record<string, any> = {};
    if (masterDescriptor.horizontalLevel) {
        styles['--nested-padding'] = `${masterDescriptor.horizontalLevel * 20}px`;
    }
    if (highlightedMappingsMap.hasOwnProperty(masterDescriptor.id)) {
        styles['--confidence-color'] = getColorFromConfidence(highlightedMappingsMap[masterDescriptor.id]);
    }
    if (masterDescriptor.style?.backgroundColor) {
        styles['--custom-bg'] = masterDescriptor.style.backgroundColor;
    }

    let classes = 'master-descriptor';
    if (styles['--nested-padding']) {
        classes = `${classes} nested-padding`;
    }
    if (styles['--confidence-color']) {
        classes = `${classes} confidence`;
    }
    if (styles['--custom-bg']) {
        classes = `${classes} custom-background`;
    }
    if (highlightedMappingsMap.hasOwnProperty(masterDescriptor.id)) {
        classes = `${classes} highlighted`;
    }

    return { styles, classes };
}
